import delay from 'delay'
import ms from 'ms'

const WATCH_TX_DELAY = ms('5s')
const WATCH_TX_TIMEOUT = ms('5m')

// this could go to asset-lib
export const createWatchTx =
  ({
    walletAccount,
    getTxLog,
    baseAsset,
    watchTxDelay = WATCH_TX_DELAY,
    watchTxTimeout = WATCH_TX_TIMEOUT,
  }) =>
  async (txId) => {
    const start = Date.now()
    let txConfirmed = false
    let hasTimedOut = false

    while (!hasTimedOut && !txConfirmed) {
      await delay(watchTxDelay)
      const baseAssetTxLog = await getTxLog({
        assetName: baseAsset.name,
        walletAccount,
      })
      txConfirmed = baseAssetTxLog.get(txId)?.confirmed
      hasTimedOut = Date.now() - start > watchTxTimeout
    }

    if (!txConfirmed) {
      throw new Error("The transaction wasn't confirmed in time.")
    }

    return { txId }
  }
